import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { Table, PageHeader } from '../../../components/UI';
import { usePermissions } from '../../../hooks/usePermissions';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

export default function UserMaster() {
  const { canBlock, canEdit } = usePermissions();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  const load = () => { setLoading(true); api.get('/masters/users').then(r=>setItems(r.users||[])).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);

  const toggleStatus = async (user) => {
    const newStatus = user.status === 'active' ? 'blocked' : 'active';
    await api.put(`/masters/users/${user.id}/status`, { status: newStatus });
    toast.success(`User ${newStatus}`); load();
  };

  const filtered = items.filter(u => !search || u.name?.toLowerCase().includes(search.toLowerCase()) || u.mobile?.includes(search));

  const columns = [
    {key:'name',label:'Name'},
    {key:'mobile',label:'Mobile'},
    {key:'email',label:'Email'},
    {key:'status',label:'Status',render:r=>(
      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${r.status==='active'?'bg-green-100 text-green-700':'bg-red-100 text-red-700'}`}>{r.status}</span>
    )},
    {key:'last_login',label:'Last Login',render:r=>r.last_login?format(new Date(r.last_login),'dd/MM/yyyy'):'-'},
    {key:'created_at',label:'Registered',render:r=>format(new Date(r.created_at),'dd/MM/yyyy')},
    {key:'actions',label:'Action',render:r=>(
      <div className="flex gap-2">
        {canBlock('masters_users') && (
          <button onClick={()=>toggleStatus(r)} className={`text-xs px-2 py-1 rounded border ${r.status==='active'?'bg-red-50 text-red-600 border-red-200':'bg-green-50 text-green-600 border-green-200'}`}>
            {r.status==='active'?'🚫 Block':'✅ Unblock'}
          </button>
        )}
        {!canBlock('masters_users') && <span className="text-xs text-gray-400">—</span>}
      </div>
    )}
  ];

  return (
    <div>
      <PageHeader title="Citizen / User Master" subtitle="Manage registered citizens" />
      <div className="mb-4"><input className="form-input max-w-sm" placeholder="Search by name or mobile..." value={search} onChange={e=>setSearch(e.target.value)} /></div>
      <div className="card overflow-hidden p-0"><Table columns={columns} data={filtered} loading={loading} /></div>
    </div>
  );
}